import { useAccount } from '@/api/rest/users/useAccount';
import { AccountRegions } from '@payaca/types/accountTypes';

export const useRegion = (): AccountRegions => {
  return useAccount()?.region ?? AccountRegions.UK;
};
